export const COUNTRIES = [
  {
    name: 'India',
    phoneCountryCode: '+91',
    file_url: '🇮🇳',
  },
  {
    name: 'USA',
    phoneCountryCode: '+1',
    file_url: '🇺🇸',
  },
  {
    name: 'Canada',
    phoneCountryCode: '+1',
    file_url: '🇨🇦'
  },
  {
    name: 'UK',
    phoneCountryCode: '+44',
    file_url: '🇬🇧'
  },
  {
    name: 'Australia',
    phoneCountryCode: '+61',
    file_url: '🇦🇺'
  },
  {
    name: 'Sri Lanka',
    phoneCountryCode: '+94',
    file_url: '🇱🇰'
  },
  {
    name: 'United Arab Emirates',
    phoneCountryCode: '+971',
    file_url: '🇦🇪'
  },
  {
    name: 'Saudi Arabia',
    phoneCountryCode: '+966',
    file_url: '🇸🇦'
  },
  {
    name: 'Kuwait',
    phoneCountryCode: '+965',
    file_url: '🇰🇼'
  },
  {
    name: 'Qatar',
    phoneCountryCode: '+974',
    file_url: '🇶🇦'
  },
  {
    name: 'Oman',
    phoneCountryCode: '+968',
    file_url: '🇴🇲'
  },
  {
    name: 'Nepal',
    phoneCountryCode: '+977',
    file_url: '🇳🇵'
  },
  {
    name: 'Pakistan',
    phoneCountryCode: '+92',
    file_url: '🇵🇰'
  },
  {
    name: 'Germany',
    phoneCountryCode: '+49',
    file_url: '🇩🇪'
  },
  {
    name: 'Poland',
    phoneCountryCode: '+48',
    file_url : '🇵🇱'
  },
  {
    name: 'New Zealand',
    phoneCountryCode: '+64',
    file_url: '🇳🇿'
  },
  {
    name: 'South Africa',
    phoneCountryCode: '+27',
    file_url: '🇿🇦'
  },
  {
    name: 'Bangladesh',
    phoneCountryCode: '+880',
    file_url: '🇧🇩'
  },
  {
    name: 'Zimbabwe',
    phoneCountryCode: '+263',
    file_url: '🇿🇼'
  },

  {
    name: 'Algeria',
    phoneCountryCode: '+213',
    file_url: '🇩🇿'
  },
  {
    name: 'Andorra',
    phoneCountryCode: '+376',
    file_url: '🇦🇩'
  },
  {
    name: 'Angola',
    phoneCountryCode: '+244',
    file_url: '🇦🇴'
  },
  {
    name: 'Anguilla',
    phoneCountryCode: '1264',
    file_url: '🇦🇮'
  },
  {
    name: 'Antigua & Barbuda',
    phoneCountryCode: '+1268',
    file_url: '🇦🇬'
  },
  {
    name: 'Argentina',
    phoneCountryCode: '+54',
    file_url: '🇦🇷'
  },
  {
    name: 'Armenia',
    phoneCountryCode: '+374',
    file_url: '🇦🇲'
  },
  {
    name: 'Aruba',
    phoneCountryCode: '+297',
    file_url: '🇦🇼'
  },
  {
    name: 'Austria',
    phoneCountryCode: '+43',
    file_url: '🇦🇹'
  },
  {
    name: 'Azerbaijan',
    phoneCountryCode: '+994',
    file_url: '🇦🇿'
  },
  {
    name: 'Bahamas',
    phoneCountryCode: '+1242',
    file_url: '🇧🇸'
  },
  {
    name: 'Bahrain',
    phoneCountryCode: '+973',
    file_url: '🇧🇭'
  },
  {
    name: 'Barbados',
    phoneCountryCode: '+1246',
    file_url: '🇧🇧'
  },
  {
    name: 'Belarus',
    phoneCountryCode: '+375',
    file_url: '🇧🇾'
  },
  {
    name: 'Belgium',
    phoneCountryCode: '+32',
    file_url: '🇧🇪'
  },
  {
    name: 'Belize',
    phoneCountryCode: '+501',
    file_url: '🇧🇿'
  },
  {
    name: 'Benin',
    phoneCountryCode: '+229',
    file_url: '🇧🇯'
  },
  {
    name: 'Bermuda',
    phoneCountryCode: '+1441',
    file_url: '🇧🇲'
  },
  {
    name: 'Bhutan',
    phoneCountryCode: '+975',
    file_url: '🇧🇹'
  },
  {
    name: 'Bolivia',
    phoneCountryCode: '+591',
    file_url: '🇧🇴'
  },
  {
    name: 'Bosnia Herzegovina',
    phoneCountryCode: '+387',
    file_url: '🇧🇦'
  },
  {
    name: 'Botswana',
    phoneCountryCode: '+267',
    file_url: '🇧🇼'
  },
  {
    name: 'Brazil',
    phoneCountryCode: '+55',
    file_url: '🇧🇷'
  },
  {
    name: 'Brunei',
    phoneCountryCode: '+673',
    file_url: '🇧🇳'
  },
  {
    name: 'Bulgaria',
    phoneCountryCode: '+359',
    file_url: '🇧🇬'
  },
  {
    name: 'Burkina Faso',
    phoneCountryCode: '+226',
    file_url: '🇧🇫'
  },
  {
    name: 'Burundi',
    phoneCountryCode: '+257',
    file_url: '🇧🇮'
  },
  {
    name: 'Cambodia',
    phoneCountryCode: '+855',
    file_url: '🇰🇭'
  },
  {
    name: 'Cameroon',
    phoneCountryCode: '+237',
    file_url: '🇨🇲'
  },
  {
    name: 'Cape Verde Islands',
    phoneCountryCode: '+238',
    file_url: '🇨🇻'
  },
  {
    name: 'Cayman Islands',
    phoneCountryCode: '+1345',
    file_url: '🇰🇾'
  },
  {
    name: 'Central African Republic',
    phoneCountryCode: '+236',
    file_url: '🇨🇫'
  },
  {
    name: 'Chile',
    phoneCountryCode: '+56',
    file_url: '🇨🇱'
  },
  {
    name: 'China',
    phoneCountryCode: '+86',
    file_url: '🇨🇳'
  },
  {
    name: 'Colombia',
    phoneCountryCode: '+57',
    file_url: '🇨🇴'
  },
  {
    name: 'Comoros',
    phoneCountryCode: '+269',
    file_url: '🇰🇲'
  },
  {
    name: 'Congo',
    phoneCountryCode: '+242',
    file_url: '🇨🇩'
  },
  {
    name: 'Cook Islands',
    phoneCountryCode: '+682',
    file_url: '🇨🇰'
  },
  {
    name: 'Costa Rica',
    phoneCountryCode: '+506',
    file_url: '🇨🇷'
  },
  {
    name: 'Croatia',
    phoneCountryCode: '+385',
    file_url: '🇭🇷'
  },
  {
    name: 'Cyprus - North',
    phoneCountryCode: '+90',
    file_url: '🇨🇾'
  },
  {
    name: 'Czech Republic',
    phoneCountryCode: '+420',
    file_url: '🇨🇿'
  },
  {
    name: 'Denmark',
    phoneCountryCode: '+45',
    file_url: '🇩🇰'
  },
  {
    name: 'Djibouti',
    phoneCountryCode: '+253',
    file_url: '🇩🇯'
  },
  {
    name: 'Dominica',
    phoneCountryCode: '+1809',
    file_url: '🇩🇲'
  },
  {
    name: 'Dominican Republic',
    phoneCountryCode: '+1809',
    file_url: '🇩🇴'
  },
  {
    name: 'Ecuador',
    phoneCountryCode: '+593',
    file_url: '🇪🇨'
  },
  {
    name: 'Egypt',
    phoneCountryCode: '+20',
    file_url: '🇪🇬'
  },
  {
    name: 'El Salvador',
    phoneCountryCode: '+503',
    file_url: '🇸🇻'
  },
  {
    name: 'Equatorial Guinea',
    phoneCountryCode: '+240',
    file_url: '🇬🇶'
  },
  {
    name: 'Eritrea',
    phoneCountryCode: '+291',
    file_url: '🇪🇷'
  },
  {
    name: 'Estonia',
    phoneCountryCode: '+372',
    file_url: '🇪🇪'
  },
  {
    name: 'Ethiopia',
    phoneCountryCode: '+251',
    file_url: '🇪🇹'
  },
  {
    name: 'Falkland Islands',
    phoneCountryCode: '+500',
    file_url: '🇫🇰'
  },
  {
    name: 'Faroe Islands',
    phoneCountryCode: '+298',
    file_url: '🇫🇴'
  },
  {
    name: 'Fiji',
    phoneCountryCode: '+679',
    file_url: '🇫🇯'
  },
  {
    name: 'Finland',
    phoneCountryCode: '+358',
    file_url: '🇫🇮'
  },
  {
    name: 'France',
    phoneCountryCode: '+33',
    file_url: '🇫🇷'
  },
  {
    name: 'French Guiana',
    phoneCountryCode: '+594',
    file_url: '🇬🇫'
  },
  {
    name: 'French Polynesia',
    phoneCountryCode: '+689',
    file_url: '🇵🇫'
  },
  {
    name: 'Gabon',
    phoneCountryCode: '+241',
    file_url: '🇬🇦'
  },
  {
    name: 'Gambia',
    phoneCountryCode: '+220',
    file_url: '🇬🇲'
  },
  {
    name: 'Georgia',
    phoneCountryCode: '+7880',
    file_url: '🇬🇪'
  },
  {
    name: 'Ghana',
    phoneCountryCode: '+233',
    file_url: '🇬🇭'
  },
  {
    name: 'Gibraltar',
    phoneCountryCode: '+350',
    file_url: '🇬🇮'
  },
  {
    name: 'Greece',
    phoneCountryCode: '+30',
    file_url: '🇬🇷'
  },
  {
    name: 'Greenland',
    phoneCountryCode: '+299',
    file_url: '🇬🇱'
  },
  {
    name: 'Grenada',
    phoneCountryCode: '+1473',
    file_url: '🇬🇩'
  },
  {
    name: 'Guadeloupe',
    phoneCountryCode: '+590',
    file_url: '🇬🇵'
  },
  {
    name: 'Guam',
    phoneCountryCode: '+671',
    file_url: '🇬🇺'
  },
  {
    name: 'Guatemala',
    phoneCountryCode: '+502',
    file_url: '🇬🇹'
  },
  {
    name: 'Guinea',
    phoneCountryCode: '+224',
    file_url: '🇬🇳'
  },
  {
    name: 'Guinea - Bissau',
    phoneCountryCode: '+245',
    file_url: '🇬🇼'
  },
  {
    name: 'Guyana',
    phoneCountryCode: '+592',
    file_url: '🇬🇾'
  },
  {
    name: 'Haiti',
    phoneCountryCode: '+509',
    file_url: '🇭🇹'
  },
  {
    name: 'Honduras',
    phoneCountryCode: '+504',
    file_url: '🇭🇳'
  },
  {
    name: 'Hong Kong',
    phoneCountryCode: '+852',
    file_url: '🇭🇰'
  },
  {
    name: 'Hungary',
    phoneCountryCode: '+36',
    file_url: '🇭🇺'
  },
  {
    name: 'Iceland',
    phoneCountryCode: '+354',
    file_url: '🇮🇸'
  },
  {
    name: 'Indonesia',
    phoneCountryCode: '+62',
    file_url: '🇮🇩'
  },
  {
    name: 'Iraq',
    phoneCountryCode: '+964',
    file_url: '🇮🇶'
  },
  {
    name: 'Ireland',
    phoneCountryCode: '+353',
    file_url: '🇮🇪'
  },
  {
    name: 'Israel',
    phoneCountryCode: '+972',
    file_url: '🇮🇱'
  },
  {
    name: 'Italy',
    phoneCountryCode: '+39',
    file_url: '🇮🇹'
  },
  {
    name: 'Jamaica',
    phoneCountryCode: '+1876',
    file_url: '🇯🇲'
  },
  {
    name: 'Japan',
    phoneCountryCode: '+81',
    file_url: '🇯🇵'
  },
  {
    name: 'Jordan',
    phoneCountryCode: '+962',
    file_url: '🇯🇴'
  },
  {
    name: 'Kazakhstan',
    phoneCountryCode: '+7',
    file_url: '🇰🇿'
  },
  {
    name: 'Kenya',
    phoneCountryCode: '+254',
    file_url: '🇰🇪'
  },
  {
    name: 'Kiribati',
    phoneCountryCode: '+686',
    file_url: '🇰🇮'
  },
  {
    name: 'Korea - South',
    phoneCountryCode: '+82',
    file_url: '🇰🇷'
  },
  {
    name: 'Kyrgyzstan',
    phoneCountryCode: '996',
    file_url: '🇰🇬'
  },
  {
    name: 'Laos',
    phoneCountryCode: '856',
    file_url: '🇱🇦'
  },
  {
    name: 'Latvia',
    phoneCountryCode: '371',
    file_url: '🇱🇻'
  },
  {
    name: 'Lebanon',
    phoneCountryCode: '961',
    file_url: '🇱🇧'
  },
  {
    name: 'Lesotho',
    phoneCountryCode: '266',
    file_url: '🇱🇸'
  },
  {
    name: 'Liberia',
    phoneCountryCode: '231',
    file_url: '🇱🇷'
  },
  {
    name: 'Libya',
    phoneCountryCode: '218',
    file_url: '🇱🇾'
  },
  {
    name: 'Liechtenstein',
    phoneCountryCode: '417',
    file_url: '🇱🇮'
  },
  {
    name: 'Lithuania',
    phoneCountryCode: '370',
    file_url: '🇱🇹'
  },
  {
    name: 'Luxembourg',
    phoneCountryCode: '352',
    file_url: '🇱🇺'
  },
  {
    name: 'Macao',
    phoneCountryCode: '853',
    file_url: '🇲🇴'
  },
  {
    name: 'Macedonia',
    phoneCountryCode: '389',
    file_url: '🇲🇰'
  },
  {
    name: 'Madagascar',
    phoneCountryCode: '261',
    file_url: '🇲🇬'
  },
  {
    name: 'Malawi',
    phoneCountryCode: '265',
    file_url: '🇲🇼'
  },
  {
    name: 'Malaysia',
    phoneCountryCode: '60',
    file_url: '🇲🇾'
  },
  {
    name: 'Maldives',
    phoneCountryCode: '960',
    file_url: '🇲🇻'
  },
  {
    name: 'Mali',
    phoneCountryCode: '223',
    file_url: '🇲🇱'
  },
  {
    name: 'Malta',
    phoneCountryCode: '356',
    file_url: '🇲🇹'
  },
  {
    name: 'Marshall Islands',
    phoneCountryCode: '692',
    file_url: '🇲🇭'
  },
  {
    name: 'Martinique',
    phoneCountryCode: '596',
    file_url: '🇲🇶'
  },
  {
    name: 'Mauritania',
    phoneCountryCode: '222',
    file_url: '🇲🇷'
  },
  {
    name: 'Mayotte',
    phoneCountryCode: '269',
    file_url: '🇾🇹'
  },
  {
    name: 'Mexico',
    phoneCountryCode: '52',
    file_url: '🇲🇽'
  },
  {
    name: 'Micronesia',
    phoneCountryCode: '691',
    file_url: '🇫🇲'
  },
  {
    name: 'Moldova',
    phoneCountryCode: '373',
    file_url: '🇲🇩'
  },
  {
    name: 'Monaco',
    phoneCountryCode: '377',
    file_url: '🇲🇨'
  },
  {
    name: 'Mongolia',
    phoneCountryCode: '976',
    file_url: '🇲🇳'
  },
  {
    name: 'Montserrat',
    phoneCountryCode: '1664',
    file_url: '🇲🇸'
  },
  {
    name: 'Morocco',
    phoneCountryCode: '212',
    file_url: '🇲🇦'
  },
  {
    name: 'Mozambique',
    phoneCountryCode: '258',
    file_url: '🇲🇿'
  },
  {
    name: 'Myanmar',
    phoneCountryCode: '95',
    file_url: '🇲🇲'
  },
  {
    name: 'Namibia',
    phoneCountryCode: '264',
    file_url: '🇳🇦'
  },
  {
    name: 'Nauru',
    phoneCountryCode: '674',
    file_url: '🇳🇷'
  },
  {
    name: 'Netherlands',
    phoneCountryCode: '31',
    file_url: '🇳🇱'
  },
  {
    name: 'New Caledonia',
    phoneCountryCode: '687',
    file_url: '🇳🇨'
  },
  {
    name: 'New Zealand',
    phoneCountryCode: '64',
    file_url: '🇳🇿'
  },
  {
    name: 'Nicaragua',
    phoneCountryCode: '505',
    file_url: '🇳🇮'
  },
  {
    name: 'Niger',
    phoneCountryCode: '227',
    file_url: '🇳🇪'
  },
  {
    name: 'Nigeria',
    phoneCountryCode: '234',
    file_url: '🇳🇬'
  },
  {
    name: 'Niue',
    phoneCountryCode: '683',
    file_url: '🇳🇺'
  },
  {
    name: 'Norfolk Islands',
    phoneCountryCode: '672',
    file_url: '🇳🇫'
  },
  {
    name: 'Northern Marianas',
    phoneCountryCode: '670',
    file_url: '🇲🇵'
  },
  {
    name: 'Norway',
    phoneCountryCode: '47',
    file_url: '🇳🇴'
  },
  {
    name: 'Palau',
    phoneCountryCode: '680',
    file_url: '🇵🇼'
  },
  {
    name: 'Panama',
    phoneCountryCode: '507',
    file_url: '🇵🇦'
  },
  {
    name: 'Papua New Guinea',
    phoneCountryCode: '675',
    file_url: '🇵🇬'
  },
  {
    name: 'Paraguay',
    phoneCountryCode: '595',
    file_url: '🇵🇾'
  },
  {
    name: 'Peru',
    phoneCountryCode: '51',
    file_url: '🇵🇪'
  },
  {
    name: 'Philippines',
    phoneCountryCode: '63',
    file_url: '🇵🇭'
  },
  {
    name: 'Portugal',
    phoneCountryCode: '351',
    file_url: '🇵🇹'
  },
  {
    name: 'Puerto Rico',
    phoneCountryCode: '1787',
    file_url: '🇵🇷'
  },
  {
    name: 'Reunion',
    phoneCountryCode: '262',
    file_url: '🇷🇪'
  },
  {
    name: 'Romania',
    phoneCountryCode: '40',
    file_url: '🇷🇴'
  },
  {
    name: 'Russia',
    phoneCountryCode: '7',
    file_url: '🇷🇺'
  },
  {
    name: 'Rwanda',
    phoneCountryCode: '250',
    file_url: '🇷🇼'
  },
  {
    name: 'San Marino',
    phoneCountryCode: '378',
    file_url: '🇸🇲'
  },
  {
    name: 'Sao Tome & Principe',
    phoneCountryCode: '239',
    file_url: '🇸🇹'
  },
  {
    name: 'Senegal',
    phoneCountryCode: '221',
    file_url: '🇸🇳'
  },
  {
    name: 'Serbia',
    phoneCountryCode: '381',
    file_url: '🇷🇸'
  },
  {
    name: 'Seychelles',
    phoneCountryCode: '248',
    file_url: '🇸🇨'
  },
  {
    name: 'Sierra Leone',
    phoneCountryCode: '232',
    file_url: '🇸🇱'
  },
  {
    name: 'Singapore',
    phoneCountryCode: '65',
    file_url: '🇸🇬'
  },
  {
    name: 'Slovak Republic',
    phoneCountryCode: '421',
    file_url: '🇸🇰'
  },
  {
    name: 'Slovenia',
    phoneCountryCode: '386',
    file_url: '🇸🇮'
  },
  {
    name: 'Solomon Islands',
    phoneCountryCode: '677',
    file_url: '🇸🇧'
  },
  {
    name: 'Somalia',
    phoneCountryCode: '252',
    file_url: '🇸🇴'
  },
  {
    name: 'Spain',
    phoneCountryCode: '34',
    file_url: '🇪🇸'
  },
  {
    name: 'Sri Lanka',
    phoneCountryCode: '94',
    file_url: '🇱🇰'
  },
  {
    name: 'St. Helena',
    phoneCountryCode: '290',
    file_url: '🇸🇭'
  },
  {
    name: 'St. Kitts',
    phoneCountryCode: '1869',
    file_url: '🇰🇳'
  },
  {
    name: 'St. Lucia',
    phoneCountryCode: '1758',
    file_url: '🇱🇨'
  },
  {
    name: 'Suriname',
    phoneCountryCode: '597',
    file_url: '🇸🇷'
  },
  {
    name: 'Sudan',
    phoneCountryCode: '249',
    file_url: '🇸🇩'
  },
  {
    name: 'Sweden',
    phoneCountryCode: '46',
    file_url: '🇸🇪'
  },
  {
    name: 'Switzerland',
    phoneCountryCode: '41',
    file_url: '🇨🇭'
  },
  {
    name: 'Taiwan',
    phoneCountryCode: '886',
    file_url: '🇹🇼'
  },
  {
    name: 'Tajikistan',
    phoneCountryCode: '992',
    file_url: '🇹🇯'
  },
  {
    name: 'Thailand',
    phoneCountryCode: '66',
    file_url: '🇹🇭'
  },
  {
    name: 'Togo',
    phoneCountryCode: '228',
    file_url: '🇹🇬'
  },
  {
    name: 'Tonga',
    phoneCountryCode: '676',
    file_url: '🇹🇴'
  },
  {
    name: 'Trinidad & Tobago',
    phoneCountryCode: '1868',
    file_url: '🇹🇹'
  },
  {
    name: 'Tunisia',
    phoneCountryCode: '216',
    file_url: '🇹🇳'
  },
  {
    name: 'Turkey',
    phoneCountryCode: '90',
    file_url: '🇹🇷'
  },
  {
    name: 'Turkmenistan',
    phoneCountryCode: '993',
    file_url: '🇹🇲'
  },
  {
    name: 'Turks & Caicos Islands',
    phoneCountryCode: '1649',
    file_url: '🇹🇨'
  },
  {
    name: 'Tuvalu',
    phoneCountryCode: '688',
    file_url: '🇹🇻'
  },
  {
    name: 'Uganda',
    phoneCountryCode: '256',
    file_url: '🇺🇬'
  },
  {
    name: 'Ukraine',
    phoneCountryCode: '380',
    file_url: '🇺🇦'
  },
  {
    name: 'Uruguay',
    phoneCountryCode: '598',
    file_url: '🇺🇾'
  },
  {
    name: 'Uzbekistan',
    phoneCountryCode: '998',
    file_url: '🇺🇿'
  },
  {
    name: 'Vanuatu',
    phoneCountryCode: '678',
    file_url: '🇻🇺'
  },
  {
    name: 'Vatican City',
    phoneCountryCode: '379',
    file_url: '🇻🇦'
  },
  {
    name: 'Venezuela',
    phoneCountryCode: '58',
    file_url: '🇻🇪'
  },
  {
    name: 'Vietnam',
    phoneCountryCode: '84',
    file_url: '🇻🇳'
  },
  {
    name: 'Virgin Islands - British',
    phoneCountryCode: '1',
    file_url: '🇻🇬'
  },
  {
    name: 'Virgin Islands - US',
    phoneCountryCode: '1',
    file_url: '🇻🇮'
  },
  {
    name: 'Wallis & Futuna',
    phoneCountryCode: '681',
    file_url: '🇼🇫'
  },
  {
    name: 'Yemen (North)',
    phoneCountryCode: '969',
    file_url: '🇾🇪'
  },
  {
    name: 'Zambia',
    phoneCountryCode: '260',
    file_url: '🇿🇲'
  }
];
